import { ALL_CREATE_ROOM_TYPE_PROPERTIES } from '../../types/sharedTypes';
import { selectIsDualLimitAutoEnabled } from '../reducers/createGameReducer';
export const CLEAR_CREATE_GAME_DIALOG = 'CLEAR_CREATE_ROOM_DIALOG';
export const SET_ROOM_TYPE = 'SET_ROOM_TYPE';
export const SET_ROOM_NAME = 'SET_ROOM_NAME';
export const SET_GAME_SPEED_INDEX = 'SET_GAME_SPEED_INDEX';
export const SET_BUY_IN_INDEX = 'SET_BUY_IN_INDEX';
export const SET_BUY_IN_RANGE = 'SET_BUY_IN_RANGE';
export const SET_BLINDS_INDEX = 'SET_BLINDS_INDEX';
export const SET_VARIANT_ID = 'SET_VARIANT_ID';
export const SET_CURRENCY_INDEX = 'SET_CURRENCY_INDEX';
export const SET_NUM_SEATS = 'SET_NUM_SEATS';
export const SET_NUM_MTT_SEATS = 'SET_NUM_MTT_SEATS';
export const SET_IS_AGGRO_BETTING_FILTER_ENABLED = 'SET_IS_AGGRO_BETTING_FILTER_ENABLED';
export const SET_IS_DUAL_LIMIT_ENABLED = 'SET_IS_DUAL_LIMIT_ENABLED';
export const SET_IS_SIDE_BETS_PHASE_ENABLED = 'SET_IS_SIDE_BETS_PHASE_ENABLED';
export const SET_IS_POWER_PLAYERS_ONLY = 'SET_IS_POWER_PLAYERS_ONLY';
export function clearCreateGameDialog() {
    return {
        type: CLEAR_CREATE_GAME_DIALOG
    };
}
export function setCreateGameType(roomType) {
    return {
        type: SET_ROOM_TYPE,
        payload: roomType
    };
}
export function setCreateGameName(roomName) {
    return {
        type: SET_ROOM_NAME,
        payload: roomName
    };
}
export function setCreateGameSpeedIndex(gameSpeedIndex) {
    return {
        type: SET_GAME_SPEED_INDEX,
        payload: gameSpeedIndex
    };
}
function setCreateGameBuyInIndex(buyInIndex) {
    return {
        type: SET_BUY_IN_INDEX,
        payload: buyInIndex
    };
}
export function thunkSetCreateGameBuyInIndex(buyInIndex) {
    return function (dispatch, getState) {
        dispatch(setCreateGameBuyInIndex(buyInIndex));
        if (selectIsDualLimitAutoEnabled(getState())) {
            dispatch(setCreateGameIsDualLimitEnabled(true));
        }
    };
}
export function setCreateGameBuyInRange(buyInRange) {
    return {
        type: SET_BUY_IN_RANGE,
        payload: buyInRange
    };
}
export function setCreateGameBlindsIndex(blindsIndex) {
    return {
        type: SET_BLINDS_INDEX,
        payload: blindsIndex
    };
}
function setCreateGameVariantId(variantId) {
    return {
        type: SET_VARIANT_ID,
        payload: variantId
    };
}
export function thunkSetCreateGameVariantId(variantId) {
    return async function (dispatch, getState) {
        const currRoomType = getState().createGame.roomType;
        const { validator } = ALL_CREATE_ROOM_TYPE_PROPERTIES[currRoomType];
        if (validator && !validator({ variantId })) {
            // room type is not valid for this variant, reset it to regular
            dispatch(setCreateGameType('regular'));
        }
        dispatch(setCreateGameVariantId(variantId));
    };
}
export function setCreateGameCurrencyIndex(currencyIndex) {
    return {
        type: SET_CURRENCY_INDEX,
        payload: currencyIndex
    };
}
export function setCreateGameNumSeats(numSeats) {
    return {
        type: SET_NUM_SEATS,
        payload: numSeats
    };
}
export function setCreateGameNumMttSeats(numMttSeats) {
    return {
        type: SET_NUM_MTT_SEATS,
        payload: numMttSeats
    };
}
export function setCreateGameIsAggroBettingFilterEnabled(isAggroBettingFilterEnabled) {
    return {
        type: SET_IS_AGGRO_BETTING_FILTER_ENABLED,
        payload: isAggroBettingFilterEnabled
    };
}
export function setCreateGameIsDualLimitEnabled(isDualLimitEnabled) {
    return {
        type: SET_IS_DUAL_LIMIT_ENABLED,
        payload: isDualLimitEnabled
    };
}
export function setCreateGameIsSideBetsPhaseEnabled(isEnabled) {
    return {
        type: SET_IS_SIDE_BETS_PHASE_ENABLED,
        payload: isEnabled
    };
}
export function setCreateGameIsPowerPlayersOnly(isEnabled) {
    return {
        type: SET_IS_POWER_PLAYERS_ONLY,
        payload: isEnabled
    };
}
